function setDefinedWordsColor(color) {
    let css = `span.has-definition {color: ${color} !important; border-bottom-color: ${color} !important;}`,
      head = document.head || document.getElementsByTagName('head')[0],
      style = document.getElementById("definition-style");
    if (!style) {
        style = document.createElement("style");
        style.type = 'text/css';
        style.id = "definition-style";
        head.appendChild(style);
    }

    if (style.styleSheet)
        style.styleSheet.cssText = css;
    else {
        if(style.lastChild) {
            style.lastChild.replaceWith(document.createTextNode(css))
        } else {
            style.appendChild(document.createTextNode(css));
        }
    }
}

export default setDefinedWordsColor;
